// extracted by mini-css-extract-plugin
module.exports = {"form":"contact-module--form--1mRgZ"};